import { render } from "./iconMail.vue?vue&type=template&id=040d904b&scoped=true"
import script from "./iconMail.vue?vue&type=script&lang=js"
export * from "./iconMail.vue?vue&type=script&lang=js"

import "./iconMail.vue?vue&type=style&index=0&id=040d904b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-040d904b"

export default script